module.exports = __webpack_public_path__ + "img/1487732465.d79913ad.jpg";